import { render, staticRenderFns } from "./UserReportUpdates.vue?vue&type=template&id=36f14a96&scoped=true"
import script from "./UserReportUpdates.vue?vue&type=script&lang=js"
export * from "./UserReportUpdates.vue?vue&type=script&lang=js"
import style0 from "./UserReportUpdates.vue?vue&type=style&index=0&id=36f14a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f14a96",
  null
  
)

export default component.exports